import React, { Suspense } from 'react';
import { Route } from 'react-router-dom'
import PopupListener from '../components/PopupListener';
import PageManagmentPlaceholder from '../components/placeholders/PageManagmentPlaceholder';
const FloatingMenu = React.lazy(() => import('../components/base/floatingMenu/FloatingMenu'));

export const PageLayoutRoute = ({ settings, ...rest }) => {

  const Component = settings.component;
  const { isSettingsLoading, homePageInfo } = settings;
  return (
    <Route {...rest} render={matchProps => {
      return isSettingsLoading || !rest.language ? <PageManagmentPlaceholder /> :
        <>
          <Suspense fallback={<PageManagmentPlaceholder />}>
            <Component {...rest} isSettingsLoading={isSettingsLoading} matchProps={matchProps} {...PopupListener.getParams(matchProps)} />
          </Suspense>
          {homePageInfo && ("/" + rest.language  + homePageInfo.prefix + homePageInfo.alias === matchProps.history.location.pathname) ? (
            <Suspense fallback={<></>}><FloatingMenu isSettingsLoading={rest.isSettingsLoading} /></Suspense>
          ) : null}
        </>
    }
    } />
  )
};

